import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">观众热评</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">来自真实观众的观影反馈，看看大家都在聊什么</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {commentsData.map((comment, i) => (
            <div key={i} className="bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-primary-200 transition-all duration-300">
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    title={comment.name}
                  />
                </div>
                <div>
                  <h3 className="font-heading text-sm font-bold text-foreground-900">{comment.name}</h3>
                  <span className="text-xs text-foreground-400">{comment.date}</span>
                </div>
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed">{comment.content}</p>
              <div className="flex items-center gap-4 mt-3 pt-3 border-t border-background-200/70">
                <button className="flex items-center gap-1 text-foreground-400 hover:text-primary-500 text-xs transition-colors cursor-pointer">
                  <i className="ri-thumb-up-line"></i>
                  <span>有用</span>
                </button>
                <button className="flex items-center gap-1 text-foreground-400 hover:text-primary-500 text-xs transition-colors cursor-pointer">
                  <i className="ri-chat-1-line"></i>
                  <span>回复</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}